import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { TrackedTime } from '../../../tracked-time-data/models/tracked-time.model';
import { TrackedTimeFiltersEnum } from '../../../tracked-time-data/tracked-time-data.data';
import { TrackedTimeDataStore } from '../../../tracked-time-data/tracked-time-data.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-billed-tracked-time-list',
  templateUrl: 'billed-tracked-time-list.component.html',
  styleUrls: ['billed-tracked-time-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BilledTrackedTimeListComponent implements OnInit {
  filter: TrackedTimeFiltersEnum;
  trackedTimes$: Observable<List<TrackedTime>>;
  noTrackedTimeDescription: string;

  constructor(
    private _trackedTimeDataStore: TrackedTimeDataStore,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.filter = TrackedTimeFiltersEnum.billed;
    this.trackedTimes$ = this._trackedTimeDataStore.getSortedList(this.filter);
    this.noTrackedTimeDescription = this._translateService.instant(
      'TRACKED_TIME.EMPTY_STATE.BILLED'
    );
  }
}
